import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App.vue'
import router from './router'
import VueTheMask from 'vue-the-mask'

Vue.config.productionTip = false
Vue.use(VeeValidate)
Vue.use(VueTheMask)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
